export const ADMISSION_TYPES = { IP: "IP", OP: "OP" };

const readPatientType = (search = "") => {
  if (typeof search !== "string") return null;
  return new URLSearchParams(search).get("patient-type");
};

/** IP vs OP — pathname `/op/` or `?patient-type=outPatients` on role home routes. */
export const detectAdmissionType = (
  pathname = "",
  search = typeof window !== "undefined" ? window.location.search : ""
) => {
  if (readPatientType(search) === "outPatients") return ADMISSION_TYPES.OP;
  if (typeof pathname === "string" && pathname.includes("/op")) {
    return ADMISSION_TYPES.OP;
  }
  return ADMISSION_TYPES.IP;
};

export const admissionQueryKey = (admissionType) =>
  admissionType === ADMISSION_TYPES.OP ? "op_admission" : "ip_admission";

export const admissionQuery = (admissionType, admissionId) => {
  if (!admissionId) return {};
  return { [admissionQueryKey(admissionType)]: admissionId };
};

/** Whether the current list segment allows form edits (IP current / OP today|week|all). */
export const isActiveAdmissionStatus = (admissionType, status) => {
  if (admissionType === ADMISSION_TYPES.OP) {
    return ["today", "week", "all"].includes(status);
  }
  return status === "current";
};
